import './DeceasedName.scss';
import Store from 'state/Store';
import { connect } from 'react-redux';
import { getDeceasedDetails } from 'state/deceasedDetails/DeceasedDetailsSelectors';
import { setDeceasedDetails } from 'state/deceasedDetails/DeceasedDetailsActions';
import { SuffixList } from 'utils/Content';
import React, {
  useEffect
} from 'react';
import {
  setCanContinueFalse,
  setCanContinueTrue,
} from 'state/canContinue/CanContinueActions';
import {
  isValidMiddleName,
  isRequiredValidName,
  beaconPattern,
} from 'utils/Validation';
import { LFEBeaconDropdown, LFEBeaconInputField } from 'components/shared/LFEBeaconComponents';


const DeceasedName = ({ deceasedDetails }) => {
  const { dfName, dmName, dlName, dSuffix } = deceasedDetails;
  const { nameRegex } = beaconPattern;
  const handleInputChange = (id,event) =>{
    if (event && event.target){
      Store.dispatch(setDeceasedDetails(id, event.target.value));
    }
  };
 
  useEffect(()=>{
    const { dfName, dmName, dlName } = deceasedDetails;
    if (dfName && isRequiredValidName(dfName) && dlName && isRequiredValidName(dlName) && (dmName && isValidMiddleName(dmName) || !dmName)){
      Store.dispatch(setCanContinueTrue());
    }else{
      Store.dispatch(setCanContinueFalse());
    }
  },[deceasedDetails]);
  return (
      <div className='DDName'>
        <div className='d-name-field-row'>
          <LFEBeaconInputField id='dfName'
                               className='dn-input-field dName blocked_data'
                               data-testid='dfName-test'
                               value={dfName}
                               label='First name'
                               type='text'
                               pattern={nameRegex}
                               required={true}
                               maxlength='32'
                               min='2'
                               errorsMap={{
              required: 'Required',
              noMatchPattern: 'Invalid name'
            }}
                               onBeaconInput={(event) => handleInputChange('dfName', event)}/>
                          
          <LFEBeaconInputField id='dmName'
                               className='dn-input-field dName blocked_data'
                               data-testid='dmName-test'
                               value={dmName}
                               label='Middle name (optional)'
                               type='text'
                               pattern={nameRegex}
                               required={false}
                               maxlength='32'
                               min='1'
                               errorsMap={{ noMatchPattern: 'Invalid name' }}
                               onBeaconInput={(event) => handleInputChange('dmName', event)}/>
        </div>
        <div className='d-name-field-row'>
          <LFEBeaconInputField id='dlName'
                               className='dn-input-field dName blocked_data'
                               data-testid='dlName-test'
                               value={dlName}
                               label='Last name'
                               type='text'
                               pattern={nameRegex}
                               required={true}
                               maxlength='32'
                               min='2'
                               errorsMap={{ required: 'Required',
                               noMatchPattern: 'Invalid name' }}
                               onBeaconInput={(event) => handleInputChange('dlName', event)}/>
          <LFEBeaconDropdown id='dSuffix'
                             className='dn-input-field dSuffix blocked_data'
                             data-testid='dSuffix-test'
                             required={false}
                             value={dSuffix}
                             onBeaconChange={(event) => handleInputChange('dSuffix', event)}
                             label='Suffix (optional)'>
                              
            <option value={''} />
            {SuffixList.map((Suffix)=> {
              return <option value={Suffix}
                             key={`${Suffix}-dSuffix`}>{Suffix}</option>
            })}
            
          </LFEBeaconDropdown>
        </div>
      </div>
  );
};

const mapStateToProps = state => ({
  deceasedDetails: getDeceasedDetails(state),
});
export default connect(mapStateToProps)(DeceasedName);